// Mega menu overflow fix v2 (Ocean Rock Audio)
// The theme's built-in dropdown positioning (sections/header.liquid, adjustDropdown())
// only corrects RIGHT-edge overflow by flipping left:0 -> right:0. For wide multi-column
// panels (e.g. "Marine Equipment", 5 columns) that flip alone still overflows the LEFT
// edge of the viewport. This script runs shortly after the built-in correction and
// re-clamps the panel so it never overflows either edge at once.
document.addEventListener('DOMContentLoaded', () => {
  if (!window.matchMedia('(min-width: 992px)').matches) return;

  function fixDropdown(details) {
    const dropdown = details.querySelector('.wbmenufull');
    if (!dropdown) return;

    // Wait a beat so this runs after the theme's own adjustDropdown() has
    // already applied (and potentially mis-applied) its correction.
    setTimeout(() => {
      if (!details.open) return;

      // Reset to baseline before recalculating.
      dropdown.style.left = '0';
      dropdown.style.right = 'auto';

      requestAnimationFrame(() => {
        const rect = dropdown.getBoundingClientRect();
        const viewportWidth = window.innerWidth;
        const margin = 15;

        // How far the dropdown's right edge sticks out past the viewport (with margin).
        const overflowRight = rect.right - (viewportWidth - margin);

        if (overflowRight > 0) {
          // Shift left just enough to clear the right edge, but never push the
          // left edge past the margin -- prevents wide panels from overflowing
          // BOTH sides of the viewport at once.
          const maxShift = rect.left - margin;
          const shift = Math.min(overflowRight, maxShift);

          if (shift > 0) {
            dropdown.style.left = (-shift) + 'px';
          }
        }
      });
    }, 30);
  }

  document.querySelectorAll('details.header-mega--menu').forEach((details) => {
    const observer = new MutationObserver(() => {
      if (details.open) fixDropdown(details);
    });
    observer.observe(details, { attributes: true, attributeFilter: ['open'] });
  });

  window.addEventListener('resize', () => {
    document.querySelectorAll('details.header-mega--menu[open]').forEach(fixDropdown);
  });
});
